import React from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import { camelize } from 'inflected';
import displayName from 'component-lib/displayName';

import styles from './Textarea.scss';

export default function TextareaGenerator(type) {
    function Textarea(props) {
        const { focused, children, value } = props;

        const textareaProps = {
            ...omit(props, [
                'focused',
                'styleName',
                'styles',
                'initialValue',
                'onUpdate',
                'valid',
                'invalid',
                'dirty',
                'pristine',
                'active',
                'touched',
                'visited',
                'autofilled',
                'autofill',
                'toggleInArray',
                'toggle',
                'change',
            ]),
            autoFocus: focused,
        };

        return (
            <div className={styles['form-field']}>
                {type === 'textarea' && (
                    <textarea
                        id={type}
                        className={`${styles.textarea} ${styles['content-editable']}`}
                        {...textareaProps}
                        contentEditable="true"
                        suppressContentEditableWarning
                    />
                )}
                {type === 'contentEditable' && (
                    <div
                        className={`${styles.textarea} ${styles['content-editable']}`}
                        contentEditable="true"
                        suppressContentEditableWarning
                        {...textareaProps}
                    >
                        {value}
                    </div>
                )}
                {children}
            </div>
        );
    }

    Textarea.displayName = displayName(`Forms/Textarea/${camelize(type)}`);

    Textarea.propTypes = {
        focused: PropTypes.bool,
        disabled: PropTypes.bool,
        children: PropTypes.node,
        rows: PropTypes.number,
        value: PropTypes.node,
        toggleInArray: PropTypes.func,
        toggle: PropTypes.func,
    };

    Textarea.defaultProps = {
        rows: 3,
        focused: true,
        disabled: false,
        children: null,
        value: null,
        toggleInArray: null,
        toggle: null,
    };

    return Textarea;
}
